import { QuestionType } from "@simplyk/common";

export const isAnswerDisplayedInMemberRow = (
  questionType: QuestionType | null | undefined,
  member: { email: string | null } | null | undefined,
  answer: string | null | undefined
): boolean => {
  if (!member) {
    return false;
  }
  if (questionType === QuestionType.Name) {
    return true;
  }
  return questionType === QuestionType.Email && (Boolean(member.email) || !answer?.trim());
};
